export const content =
`

<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>CGU – Définitions, Accès, Disponibilité, Sécurité et Obligations du Client</title>
  <style>
    :root{
      --blue:#0f2a62;   /* bleu titre principal */
      --green:#4aa047;  /* vert sous-titres */
      --text:#1b1b1b;   /* couleur du corps */
      --gray:#d4d4d4;   /* fond gris pour 3.2 */
    }
    html{box-sizing:border-box;}
    *,*:before,*:after{box-sizing:inherit;}

    body{
      margin:0;
      font-family:"Segoe UI", Roboto, Arial, sans-serif;
      color:var(--text);
      line-height:1.6;
      background:#fff;
    }

    .page{
      max-width:980px;
      margin:40px auto;
      padding:0 24px 48px;
    }

    /* Titre principal (niveau 2 visuel) */
    .h2{
      display:flex;
      align-items:baseline;
      gap:16px;
      color:#0E0E4F !important;
      /*margin: 28px 0 12px;*/
      flex-wrap:wrap;
    }
    .h2 .number{
      font-weight: 800;
     /* font-size: clamp(28px, 4.2vw, 21px);*/
      letter-spacing:0.5px;
    }
    .h2 .text{
      font-weight: 800;
      text-transform: uppercase;
     /*  font-size: clamp(22px, 3.6vw, 21px);*/
    }

    /* Sous-titres 2.x */
    .subsection{
      margin: 20px 0 6px;
      color: #669848 !important;;
      display:flex;
      align-items:baseline;
      gap:14px;
      flex-wrap:wrap;
    }
    .subsection .number{
      font-weight: 800;
     /* font-size: clamp(18px, 2.4vw, 22px);*/
    }
    .subsection .text{
      font-weight: 800;
      /*font-size: clamp(18px, 2.4vw, 22px);*/
      text-transform: uppercase;
    }

   /* p{margin: 10px 0 14px; text-align: justify; /*font-size:13px;*/}*/

    .brand{ text-decoration: underline dotted; }

    /* Headline style for 3.2 with grey slab */
    .headline{ display:flex; align-items:center; gap:14px; margin: 28px 0 8px; }
    .headline .num{ color:var(--green); font-weight:800; /*font-size:clamp(18px,2.4vw,22px);*/}
    .headline .label{ position:relative; color:var(--green); font-weight:800; text-transform:uppercase; /*font-size:clamp(18px,2.4vw,22px)*/; padding:6px 10px; }
    .headline .label::before{ content:""; position:absolute; left:-10px; top:0; height:100%; width:220px; background:var(--gray); z-index:-1; border-radius:2px; }

    ul{ margin: 6px 0 10px 22px; padding:0; list-style-type: disc; /*font-size:13px;*/ }
    ul ul{ margin-top:6px; list-style-type: circle; }
    /*li{ margin:6px 0; }*/

    /* Section 1 style */
    .h1{
      display:flex; align-items:baseline; gap:16px; color:var(--blue); flex-wrap:wrap; margin: 8px 0 14px;
    }
    .h1 .number{ font-weight:800; /*font-size: clamp(28px, 4.2vw, 21px);*/ }
    .h1 .text{ font-weight:800; text-transform:uppercase; /*font-size: clamp(22px, 3.6vw, 21px); */}

    .term{ font-weight:700; }

    @media (prefers-color-scheme: dark){
      body{background:#0e0f12; color:#eee;}
      .h1,.h2{color:#b9cbf4;}
      .subsection{color:#a7dfb3;}
      .headline .label{color:#a7dfb3;}
      .headline .label::before{background:#3a3a3a;}
      .headline .num{color:#a7dfb3;}
    }
  </style>
</head>
<body>
  <main class="page">
<div style='border:solid windowtext 1.0pt;padding:8px;margin-bottom:10px;'>
<h1 align=center style='font-size:16.0pt;text-align:center;border:none;padding:0cm;margin:0px;'><span
lang=FR>CGU DE LA PLATEFORME</span></h1>

</div>
    <!-- Section 1: DEFINITIONS -->
    <header class="h1" aria-level="1" role="heading">
      <span class="number">1</span>
      <span class="text">Definitions</span>
    </header>

    <p><span class="term">Administrateur</span> : Salarié de F.initiatives en charge de la gestion technique et fonctionnelle de la Plateforme pour le compte du CLIENT, notamment pour la gestion des droits et des accès, conformément aux instructions du CLIENT.</p>

    <p><span class="term">CLIENT</span> désigne :</p>
    <ul>
      <li>une entité bénéficiant d’une Mission principale dans le cadre d’un Contrat de prestation de services avec <span class="brand">F.initiatives</span>, <em>ou</em></li>
      <li>une entité ayant souscrit un Devis.</li>
    </ul>

    <p><span class="term">Contenu du CLIENT</span> : Ensemble des informations saisies ou déposées par les Utilisateurs autorisés sur la Plateforme. Dans l’hypothèse où le CLIENT utiliserait la Plateforme dans le cadre de son crédit d’impôt, il est informé que le suivi des temps R&D est une composante essentielle dans la sécurisation des crédits d’impôt, et doit être rempli avec exactitude et rigueur.</p>
    <p><span class="term">Contrat de prestation de services </span> : Tout engagement contractuel (devis, convention, etc.) nécessitant l’utilisation d’une méthode de suivi du temps par le CLIENT pour justifier ses frais de personnel.</p>
    <p><span class="term">Devis </span>: Désigne tout engagement contractuel hors Contrat de prestation de services, conclu entre le <b>CLIENT </b>et F.initiatives en vue de bénéficier spécifiquement de la Plateforme.</p>
    <p><span class="term">Données personnelles </span>: Toute information permettant d’identifier directement ou indirectement une personne physique.</p>
    <p><span class="term">Guide utilisateur </span>: Contenu de référence (accessible directement depuis la Plateforme) encadrant son utilisation, à respecter en complément des présentes CGU.</p>
    <p><span class="term">Mission principale </span>: Mission réalisée par F.initiatives conformément au Contrat de prestation de services.</p>
    <p><span class="term">Informations confidentielles </span>: Toute donnée relative au CLIENT déposée sur la Plateforme, devant être traitée conformément aux dispositions du Contrat de prestation de services.</p>
    <p><span class="term">Utilisateur autorisé </span>: Personne disposant d’un accès à la Plateforme, sous réserve de la création préalable de son compte par un Utilisateur privilégié. L’Utilisateur privilégié est responsable de l’identification, de l’information et du respect des CGU par les Utilisateurs autorisés.</p>
    <p><span class="term">Utilisateur privilégié </span>: Utilisateur désigné par le CLIENT, habilité à créer et supprimer des comptes d’Utilisateurs autorisés, et interlocuteur privilégié de l’Administrateur..</p>
    <p><span class="term">Plateforme </span>: Solution SaaS de suivi du temps développée par F.initiatives et hébergée en France sur Microsoft Azure, permettant au CLIENT de structurer et justifier le temps passé sur ses projets de Recherche & Développement et d’Innovation dans le cadre de la Mission principale ou d'un Devis.</p>

    <!-- Section 2: ACCES, DISPONIBILITE ET SECURITE -->
    <header class="h2" aria-level="2" role="heading">
      <span class="number">2</span>
      <span class="text">Accès, Disponibilité et Sécurité</span>
    </header>

    <!-- 2.1 Accès à la plateforme -->
    <section aria-labelledby="sec-2-1">
      <div class="subsection" id="sec-2-1">
        <span class="number">2.1</span>
        <span class="text">Accès à la plateforme</span>
      </div>

      <p>
        L’accès à la Plateforme est accordé dans le cadre d’un Contrat de prestation de services en cours
        ou de la conclusion d’un devis conformément aux conditions convenues avec F.initiatives.
      </p>
      <p>
        Dans les deux cas, l’accès est concédé à titre non exclusif, non transférable, et limité à la durée
        prévue au sein Contrat de prestation de services ou du Devis.
      </p>
    </section>

    <!-- 2.2 Disponibilité du service -->
    <section aria-labelledby="sec-2-2">
      <div class="subsection" id="sec-2-2">
        <span class="number">2.2</span>
        <span class="text">Disponibilité du service</span>
      </div>

      <p>
        F.initiatives s’efforce de garantir une disponibilité optimale de la Plateforme.
        Des interruptions temporaires peuvent survenir pour des raisons de maintenance ou d’intervention de l’hébergeur.
        Aucune indemnité ne pourra être réclamée en cas d’indisponibilité.
      </p>
    </section>
    <!-- 2.3	SECURITE -->
    <section aria-labelledby="sec-2-2">
      <div class="subsection" id="sec-2-2">
        <span class="number">2.3</span>
        <span class="text">SECURITE</span>
      </div>
      <p>
       Chaque Utilisateur autorisé dispose d’un identifiant et d’un mot de passe personnels, qu’il s’engage à ne pas partager. Le CLIENT et ses Utilisateurs doivent adopter des pratiques de sécurité conformes aux standards (mots de passe robustes, déconnexion après usage, etc.).
       F.initiatives met en œuvre des mesures techniques et organisationnelles pour assurer la sécurité des données (authentification multifacteur, chiffrement, sauvegardes, journalisation des accès, etc.).

      </p>
    </section>
	    <!-- Section 2: ACCES, DISPONIBILITE ET SECURITE -->
    <header class="h2" aria-level="2" role="heading">
      <span class="number">3</span>
      <span class="text">OBLIGATIONS DES PARTIES</span>
    </header>

    <!-- 2.1 Accès à la plateforme -->
    <section aria-labelledby="sec-2-1">
      <div class="subsection" id="sec-2-1">
        <span class="number">3.1</span>
        <span class="text">OBLIGATIONS GENERALES</span>
      </div>
      <p>
       Chaque Partie s’engage à :
      </p>
   <ul>
				<li>Préserver la confidentialité des Informations confidentielles ;</li>
				<li>Ne pas utiliser les données en dehors des finalités prévues ; </li>
				<li>Informer l’autre Partie en cas de suspicion ou de constat d’accès non autorisé à la Plateforme.</li>
			</ul>
    </section>

    <!-- 2.2 Disponibilité du service -->
    <section aria-labelledby="sec-2-2">
      <div class="subsection" id="sec-2-2">
        <span class="number">3.2</span>
        <span class="text">OBLIGATIONS DU CLIENT</span>
      </div>

      <p>Le CLIENT s’engage à :
      </p>
	  <ul>
				<li>Délivrer des instructions claires à l’Utilisateur privilégié ;</li>
				<li>Garantir la véracité des données saisies ;</li>
				<li>Imposer aux Utilisateurs autorisés :
				<ul>
				<li>La lecture et l’acceptation des CGU ;</li>
				<li>La notification immédiate à l’Administrateur en cas de suppression ou compromission de compte ;</li>
		       	<li>L’interdiction de transférer ses identifiants.</li>
	  </ul>
			   </li>

			</ul>
    </section>

	 <!-- Section 2: ACCES, DISPONIBILITE ET SECURITE -->
    <header class="h2" aria-level="2" role="heading">
      <span class="number">4</span>
      <span class="text">PROPRIETE INTELLECTUELLE</span>
    </header>
	    <p>La Plateforme, ses composants techniques, ses interfaces, ses contenus (hors données du CLIENT) sont la propriété exclusive de F.initiatives. Le CLIENT bénéficie d’un droit d’usage limité à la durée du Contrat de prestation de services ou du Devis.</p>
        <p>Toute reproduction, modification ou diffusion non autorisée est interdite.</p>
   	 <!-- Section 2: ACCES, DISPONIBILITE ET SECURITE -->
    <header class="h2" aria-level="2" role="heading">
      <span class="number">5</span>
      <span class="text">DONNEES PERSONNELLES</span>
    </header>
 <!-- 2.1 Accès à la plateforme -->
    <section aria-labelledby="sec-2-1">
      <div class="subsection" id="sec-2-1">
        <span class="number">5.1</span>
        <span class="text">RESPONSABILITE</span>
      </div>
      <p>
       Le CLIENT est responsable du traitement des données personnelles de ses collaborateurs. F.initiatives agit en tant que sous-traitant, et Microsoft Azure en tant que sous-traitant ultérieur.
      </p>
    </section>

    <!-- 2.2 Disponibilité du service -->
    <section aria-labelledby="sec-2-2">
      <div class="subsection" id="sec-2-2">
        <span class="number">5.2 </span>
        <span class="text">DONNEES TRAITEES</span>
      </div>
      <p>
      Les données concernées incluent : nom, prénom, fonction, temps passé par projet, absences, tâches réalisées, etc.
      </p>
    </section>
    <!-- 2.3	SECURITE -->
    <section aria-labelledby="sec-2-2">
      <div class="subsection" id="sec-2-2">
        <span class="number">5.3</span>
        <span class="text"> BASE LEGALE</span>
      </div>
      <p>
       F.initiatives traite les Données personnelles du CLIENT sur la base de l'engagement contractuel conclu (Contrat de prestation de services ou Devis).
      </p><p>
Dans l'hypothèse de l'utilisation de la Plateforme au titre d'un dispositif afférent au crédit d'impôt, la base légale du traitement est le respect d’une obligation légale liée à la justification du crédit d’impôt. Le consentement des collaborateurs n’est pas requis.       </p>
    <p>
Dans l'hypothèse où le suivi des temps passés est requis ou réalisé pour toute autre utilisation ne portant pas sur un dispositif étatique, le <b>CLIENT</b> devra déterminer la base légale applicable à l'utilisation de la Plateforme en fonction de la finalité poursuivie. Le cas échéant, le <b>CLIENT</b> est informé qu'en fonction de la base légale identifiée, le consentement du collaborateur peut être requis.
  </section>
  <!-- 2.3	SECURITE -->
    <section aria-labelledby="sec-2-2">
      <div class="subsection" id="sec-2-2">
        <span class="number">5.4</span>
        <span class="text"> OPERATIONS REALISEES</span>
      </div>
      <p>
Les opérations incluent : collecte, enregistrement, organisation, conservation, extraction, consultation, utilisation, et communication le cas échéant, en cas de contrôle fiscal.      </p><p>
   </p>
  </section>
	 <!-- Section 2: ACCES, DISPONIBILITE ET SECURITE -->
    <header class="h2" aria-level="2" role="heading">
      <span class="number">6</span>
      <span class="text">ARCHIVAGE, SUPPRESSION ET EXPORT DES DONNEES</span>
    </header>
	    <p>À l’issue du Contrat de prestation ou du Devis:</p>
		<ul>
				<li>droits d’édition sont désactivés ;</li>
				<li>Un accès en lecture seule est maintenu :
				<ul>
				<li>Dans le cadre du Contrat de prestation de service : jusqu’au 31/12 de l’année N+3 (N étant l’année de fin du contrat), sous réserve du règlement intégral des factures ;</li>
				<li>Dans le cadre d'un Devis : Quatre ans à compter de la date de résiliation</li>
		       </ul>
			   </li>
				<li>Le CLIENT peut demander une exportation des données au format standard (CSV ou équivalent) avant suppression définitive.
				</li>
			</ul>
	 <!-- Section 2: ACCES, DISPONIBILITE ET SECURITE -->
    <header class="h2" aria-level="2" role="heading">
      <span class="number">7</span>
      <span class="text">ÉVOLUTIONS DES CGU</span>
    </header>
	    <p>F.initiatives se réserve le droit de modifier les présentes CGU. Toute modification substantielle sera notifiée au CLIENT, qui disposera d’un délai de 30 jours pour en prendre connaissance. L’utilisation continue de la Plateforme vaut acceptation des nouvelles CGU.</p>
    <header class="h2" aria-level="2" role="heading">
      <span class="number">8</span>
      <span class="text">SUPPORT ET ASSISTANCE</span>
    </header>
	    <p>F.initiatives met à disposition un support technique accessible par email (<a href="mailto:assistance-client@f-initiatives.com">assistance-client@f-initiatives.com</a>). Les demandes sont traitées dans un délai raisonnable, en fonction de leur complexité.</p>

 <header class="h2" aria-level="2" role="heading">
      <span class="number">9</span>
      <span class="text">SOUS-TRAITANCE ET AUDIT</span>
    </header>
	    <p>F.initiatives peut faire appel à des sous-traitants pour l’hébergement, la maintenance, les audits de sécurité ou le développement de la Plateforme, sous réserve du respect des obligations de confidentialité et de sécurité.
Le <b>CLIENT</b> est informé que F.initiatives pourra notamment recourir à la sous traitance auprès de toute société qu'elle contrôle ou qu'elle contrôlera au sens de l’article L233-3 du code de commerce - et ce même au sein d'un pays tiers -  dès lors qu’elle assure une protection des Données personnelles conforme au règlement (UE) 2016/679 du Parlement Européen et du Conseil du 27 avril 2016 et de la loi n° 2018-493 du 20 juin 2018 relative à la protection des Données personnelles.
</p>
    <header class="h2" aria-level="2" role="heading">
      <span class="number">10</span>
      <span class="text">DISPOSITIONS DIVERSES</span>
    </header>
<p>Si une des clauses des CGU venait à être déclarée nulle ou inapplicable, les autres dispositions des CGU resteront pleinement en vigueur.</p>
		<p>Le fait pour F.initiatives de ne pas se prévaloir à un moment donné de l’une des clauses des CGU ne peut pas être interprété comme une renonciation à s’en prévaloir ultérieurement.</p>
		    <header class="h2" aria-level="2" role="heading">
      <span class="number">11</span>
      <span class="text">LOI APPLICABLE ET JURIDICTION COMPETENTE</span>
    </header>
	    <p>Les présentes CGU sont régies par la loi applicable au Contrat de prestation de services ou, à défaut, par la loi française. Tout litige relatif à leur interprétation ou exécution relève de la juridiction compétente définie dans le contrat ou, à défaut, du tribunal compétent du ressort du siège social de F.initiatives.</p>
  </main>
</body>
</html>

     `;